import { render, staticRenderFns } from "./InsideDrawer.vue?vue&type=template&id=27176bfe"
import script from "./InsideDrawer.vue?vue&type=script&lang=js"
export * from "./InsideDrawer.vue?vue&type=script&lang=js"
import style0 from "./InsideDrawer.vue?vue&type=style&index=0&id=27176bfe&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/app/erp_frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('27176bfe')) {
      api.createRecord('27176bfe', component.options)
    } else {
      api.reload('27176bfe', component.options)
    }
    module.hot.accept("./InsideDrawer.vue?vue&type=template&id=27176bfe", function () {
      api.rerender('27176bfe', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/center-business/customer/onboarding/InsideDrawer.vue"
export default component.exports